import { render, staticRenderFns } from "./WsDataTablePagenate.vue?vue&type=template&id=7f15677a&"
import script from "./WsDataTablePagenate.vue?vue&type=script&lang=js&"
export * from "./WsDataTablePagenate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports